var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgStreamNode = function SvgStreamNode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stream-node_svg__stream-node_svg__clip0_61_16929)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#6E7D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.076 8.154c2.308-1.539 4.616-1.539 6.923 0 2.308 1.538 4.616 1.538 6.923 0M5.076 15.846c2.308-1.538 4.616-1.538 6.923 0 2.308 1.539 4.616 1.539 6.923 0M5.076 12c2.308-1.54 4.616-1.54 6.924 0 2.308 1.538 4.616 1.538 6.923 0",
    stroke: "#F7FBFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stream-node_svg__stream-node_svg__clip0_61_16929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
};
export default SvgStreamNode;